/* START: DATA FOR MAP */
var data = {
  // Map start center
  center: [154031, 6578889],
  // Map options
  mapOption: {
    // Double click for zoom
    doubleClickZoom: false,
    // Scroll to search input on fullscreen mode instead of map top. Adding class .s-map-fullscreen-search in body.
    scrollToSearchInput: false,
    // Maxresolution for zoom out (ESPG:3011 20km)
    maxResolution: 234.375,
    // Minresolution for zoom in (ESPG:3011 10m, 0.11444091796875), (ESPG:3011 2m, 0.0286102294921875)
    minResolution: 0.11444091796875,
    // Map extent {minX, minY, maxX, maxY}
    extent: [61500.0, 6465000.0, 301500.0, 6705000.0]
  },
  // Map zoom levels
  zoomLevel: {
    // Map start zoom
    zoom: 6,
    // Map max zoom
    maxZoom: 0,
    // Map min zoom
    minZoom: 13,
    // Zoom to popup on poi click
    singelPopupZoomLevel: 9,
    // Zoom for geolocation click
    geolocationZoomLevel: 9,
  },
  // Search address in map
  searchOptions: {
    enabled: true,
    apiUrl: "https://openstreetws.stockholm.se/LvWS-4.0/Lv.svc",
    apiKey: "94b854a6-23aa-48a2-8788-1d0ac462fb53" // SWEREF 99 18 00
  },
  // Popup cluster options
  clusterOptions: {
    // clusterPopupZoomLevel: nivå för när man klickar på clusterpopup
    clusterPopupZoomLevel: 9,
    // clusterZoomFeatureAmount: mängd av features under en cluster där man vill att inzoomning skall ske. mängd > 10  => inzoomning.
    clusterZoomFeatureAmount: 5,
    // combinedClusterLayer: super cluster lager för alla lager vilka har features
    combinedClusterLayer: true,
    // clusterIconPopupShow: om man vill att icon:en för featuren skall visas i litan i popupen
    clusterIconPopupShow: true,
    // clusterZoomLevelSwitch: zoom nivån där clusterlagret går ifrån supercluster till de individuella lagren
    clusterZoomLevelSwitch: 7,
    // clusterRadius: radius för clustringen på kartan.
    clusterRadius: 70,
    // clusterCount: aktiverar omformulering av mängd features i clustring. Defualt = true
    clusterCount: true,
    // clusterSortPopupResultByLayer: sortera multipopup på lagerordning. Default = true
    // clusterSortPopupResultByLayer: false,
    // clusterSortPopupResultByName: sortera multipopup på namn. Default = true
    // clusterSortPopupResultByName: false,
  },
  // Buttons visibility map start
  buttonVisibility: {
    // geolocationVisibility: synlighet för 'geolocation' vid start
    geolocationVisibility: false,
    // fullScreenVisibility: synlighet för 'visa i helskärm' knappen vid start.
    fullScreenVisibility: false,
    // legendtab: synlighet för 'legend tab' vid start (baseras på ifall html elementet har klasses 'hide' sen tidigare)
    legendtab: true,
    // tooltab: synlighet för 'tool tab' vid start (baseras på ifall html elementet har klasses 'hide' sen tidigare)
    tooltab: false,
    // searchtab: synlighet för 'search tab' vid start (baseras på ifall html elementet har klasses 'hide' sen tidigare)
    searchtab: false,
    // layertab: synlighet för 'layer tab' vid start (baseras på ifall html elementet har klasses 'hide' sen tidigare)
    layertab: false,
    // sharetab: synlighet för 'share tab' vid start (baseras på ifall html elementet har klasses 'hide' sen tidigare)
    sharetab: false
  },
  // tools
  tools: {
    customButton: [{
      tool: 'LineString',
      name: 'Rita linje',
      class: 'icon-map-draw-line LineString-tool',
      // id: 'går att lägga till vid behov',
    }, {
      tool: 'Polygon',
      name: 'Rita ploygon',
      class: 'icon-map-draw-poly Polygon-tool',
      // id: 'går att lägga till vid behov',
      // },{
      //     // tool: placePoi är ett verktyg där man kan lägga till ett poi i klienten genom att klicka på kartan.
      //     // alternativt kan man lägga till en ny POI genom funktionen advancedMap.createPois(layer, feature).
      //     // feature strukturen är likadan som den som finns för features i lager blocket.
      //     tool: 'placePoi',
      //     name: 'Lägg till intressepunkt',
      //     class: 'icon-map-pin pointer-tool',
      //     // id: 'går att lägga till vid behov',
      // },{
      //     tool: 'pointAdd',
      //     name: 'Lägg till punkt',
      //     class: 'icon-my-position add-tool',
      //     // id: 'går att lägga till vid behov',
    }]
  },
  // modify: Block för att ändra features sata samt att ta bort dem.
  modify: {
    // modifyPosition: Om man vill få möjligheten att flytta runt ikoner på kartan
    modifyPosition: false,
    // modifyData: Om man vill få möjligheten att ta ändra data:n för featuren sätt till true
    modifyData: false,
    // customButton: array för egna knappar placerade i popupen
    customButton: [{
      // modifyRemove: Om man vill få möjligheten att ta bort featuren
      modifyRemove: false,
      name: 'Ta bort intressepunkt',
      class: 'icon icon-map-trashcan s-map-popup-test'
    }, {
      // saveData: Om man vill få möjligheten att lägga till nya features sätt till true
      saveData: false,
      name: 'Spara intressepunkt',
      class: 'icon icon-map-upload s-map-popup-test'
    }/*,{
          // modifyEvent: Wildcard event när man trycker på en knapp för att få den aktuella featurn samt dess lager.
          modifyEvent: false,
          name: 'Redigera intressepunkt',
          class: 'icon icon-map-pin s-map-popup-test',
          // id: 'test'
        }*/
      ]
  },
  // layers: de olika lager som ingår i kartan
  layers: [
    {
      // name: lagernamn för lagret
      name: 'Stockholm',
      // Layer URL
      url: 'http://kartor.stockholm.se/bios/wms/app/baggis/web/WMS_STHLM_STADENS_MANER',
      // Visible from start
      showhide: true,
      // opactity: genomskinlighet på lager. 0-1 där 1 inte är genomskinligt alls
      opacity: 1,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: true,
        // backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: 'Bakgrundskarta',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 3,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "SERVICE": "WMS",
        "VERSION": "1.1.1",
        "REQUEST": "GetMap",
        "STYLES": "",
        "SRS": "EPSG:3011",
        "TILED": true,
        "TRANSPARENT": false
      },
      tilegrid: {
        resolutions: [234.375, 117.1875, 58.59375, 29.296875, 14.6484375, 7.32421875, 3.662109375, 1.8310546875, 0.91552734375, 0.457763671875, 0.2288818359375, 0.11444091796875],
        origin: [61500, 6465000],
        extent: [61500.0, 6465000.0, 301500.0, 6705000.0],
        tilesize: [256, 256],
      },
      // servertype: vilken typ av server det är.
      servertype: 'geoserver'
    }, {
      // name: lagernamn för lagret
      name: 'Ortofoto 2015',
      // Layer URL
      url: 'https://kartor.stockholm.se/bios/wms/app/baggis/web/WMS_STHLM_ORTOFOTO_2015',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: true,
        // backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: 'Bakgrundskarta',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager
        order: 4,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "SERVICE": "WMS",
        "VERSION": "1.1.1",
        "REQUEST": "GetMap",
        "STYLES": "",
        "SRS": "EPSG:3011",
        "TILED": true,
        "TRANSPARENT": false,
      },
      tilegrid: {
        resolutions: [117.1875, 58.59375, 29.296875, 14.6484375, 7.32421875, 3.662109375, 1.8310546875, 0.91552734375, 0.457763671875, 0.2288818359375, 0.11444091796875],
        origin: [135000, 6565000],
        extent: [135000, 6565000, 165000, 6595000],
        tilesize: [256, 256],
      },
      // servertype: vilken typ av server det är.
      servertype: 'geoserver'
    }, {
      // name: lagernamn för lagret
      name: 'Stockholm år 1805',
      // Layer URL
      url: 'https://kartor2.stockholm.se/bios/wms/app/dpmap/cust_sth/utbf/web/WMS_UTBF_1805',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: true,
        // backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: 'Historisk bakgrundskarta',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 1,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "SERVICE": "WMS",
        "VERSION": "1.1.1",
        "REQUEST": "GetMap",
        "STYLES": "",
        "SRS": "EPSG:3011",
        "TRANSPARENT": false,
        "TILED": true
      },
      tilegrid: {
        resolutions: [234.375, 117.1875, 58.59375, 29.296875, 14.6484375, 7.32421875, 3.662109375, 1.8310546875, 0.91552734375, 0.457763671875, 0.2288818359375, 0.11444091796875],
        origin: [135000, 6565000],
        extent: [135000, 6565000, 165000, 6595000],
        tilesize: [256, 256],
      },
      // servertype: vilken typ av server det är.
      servertype: 'geoserver'
    }, {
      // name: lagernamn för lagret
      name: 'Stockholm år 1934',
      // Layer URL
      url: 'https://kartor2.stockholm.se/bios/wms/app/dpmap/cust_sth/utbf/web/WMS_UTBF_1934',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: true,
        // backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: 'Historisk bakgrundskarta',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 2,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "SERVICE": "WMS",
        "VERSION": "1.1.1",
        "REQUEST": "GetMap",
        "STYLES": "",
        "SRS": "EPSG:3011",
        "TRANSPARENT": false,
        "TILED": true
      },
      tilegrid: {
        resolutions: [234.375, 117.1875, 58.59375, 29.296875, 14.6484375, 7.32421875, 3.662109375, 1.8310546875, 0.91552734375, 0.457763671875, 0.2288818359375, 0.11444091796875],
        origin: [135000, 6565000],
        extent: [135000, 6565000, 165000, 6595000],
        tilesize: [256, 256],
      },
      // servertype: vilken typ av server det är.
      servertype: 'geoserver',
      // legend: lager teckenförklaring
      legend: {
        // header: huvudrubrik för teckenförklaring
        "header": "Rubrik",
        // subheader: rubrik för ingress i tekenförklaring
        "subheader": "Ingress (kort beskrivning av kartlager)",
        // content: brödtext för teckenförklaring
        "content": [{
          //header: huvudrubrik för objekt
          "header": "Teckenrubrik",
          // text: text för objekt
          "text": "Teckenförklaring (kort beskrivning)",
          // image: bild för objekt
          "image": ""
        }, {
          //header: huvudrubrik för objekt
          "header": "",
          // text: text för objekt
          "text": "Teckenförklaring (kort beskrivning)",
          // image: bild för objekt
          "image": ""
        }]
      }
    }, {
      // Layer name
      name: 'Stadsdelsområden',
      // Layer URL
      url: 'https://kartor.stockholm.se/bios/wms/app/baggis/web/WMS_STHLM_STDELAR_STDELSNAMNDER_TS',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 1,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "VERSION": "1.1.1"
      },
      // zoom ut: yttersta nivån lagret ska visas på
      minZoom: 4,
      // zoom in: lägsta nivån lagret ska visas på
      maxZoom: 9,
      // servertype: vilken typ av server det är.
      servertype: 'geoserver',
      // legend: lager teckenförklaring
      legend: {
        // header: huvudrubrik för teckenförklaring
        "header": "Stadsdelsområden",
        // subheader: rubrik för ingress i tekenförklaring
        "subheader": "Ingress exempel (kort beskrivning av kartlager)",
        // content: brödtext för teckenförklaring
        "content": [{
          "text": "Stadsdelsområde",
          "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAADCAYAAADyQg1sAAAAF0lEQVQYlWNk91/9n2EAAdNAWj4oHAAABZcCBj7I1+sAAAAASUVORK5CYII="
        }, {
          "text": "Stadsdel",
          "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACCAYAAAA5Ht7JAAAAGElEQVQYlWP8rej3n2EAAdNAWs7AwMAAAGrTAm2nw39KAAAAAElFTkSuQmCC"
        }, {
          // header: huvudrubrik för objekt
          "header": "Teckenrubrik exempel",
          // text: text för objekt
          "text": "Teckenförklaring text exempel bildstorlek 32x32px",
          // image: bild för objekt
          "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC1ElEQVRYhb2WW08TQRiGn9nd2ZaDXrBbTIiSaOIvANtySvSOeGv8KeqVp0T/i8R4iAYpkQCJJ/AYxT8ASEsRrsDIDnbHi11Kd9rbzuVm3p3nm+3zfVPUyq7ev/VNqw+/tdZaq7c7+uD29+bz0ec9ffDwp1bv0/VVI/9mRx/cacl/2dMHD9a0ereTrH/a1fs3v2q1unuSv/tDq5Uk78lSAFqjFuvgCOREAVxB9HILGho5UUBHjeRZgCyHEKd5IZCTBfAE0YstiDVyvID+2yCarYLrIEsBxKAWtpP1yQL4DtGzTYjBO/q4l2zqCKInG+CAe6Gf3NUh1HIdkXeR40lR6lUV/qWbQLJJa1HLO4ic2zyEmt2CozjJx5ro+a/kkMUAGhq1VMc7hspiAA6oSg3/yhnkRAHR43L4aJ08IEshHGnU4jb4TrNoVamCSiAi53I4s07+uKhG+qVyaV6AmjvJy7EQL3d9GFWpQRQnlUcxar4GrkCWQ/IaovkaOn0J3yF6upl8znIIKka9roGX5gVEc1X0YSPZL+cQPd4A3XKIhW2QAlkK8eRokIXadgBog7oXT9lz4M/9NfzpoZPfbLlOLu/ac8CfHkpOonUb1BsZsOCAOQeKQRY6FlpwwJwDw334lwdPoFYcKLXPgTZo1x0oh21zIAO14oA5BzpBu+6AeRcUgyy0HNpxIDMHOkFtOGC2pAntvgOd7oJWqBUHOs0BA9p9BzrdBa3QcRsOmC1pQL2RAUsOtLZkKchCrTnQ2pLFIAu15oDZkia06w50uAsyUCsOmC1pQos2HDBbctSAputddyAzB9ILrAm15YDZkia0+w60zQFDPCsOdJoDLVA5FjYdcG+Ia/dEj4d7vg/nbC+qUsM5LZETBZx+j8OZdZyBHPJSgJAOanEb0eMhSyHitERVqoh0+Di9aT5I876DWqojepM/NaLPQy3V8acGcc/14k8N8h/dQ+vXqPgAUgAAAABJRU5ErkJggg=="
        }]
      }
    }, {
      // Layer name
      name: 'Cykelparkering - POINT',
      // Layer URL
      url: 'http://openstreetgs.stockholm.se/geoservice/api/717ec6af-49f9-4774-84da-35b8cb713dc5/wms',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 1,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "VERSION": "1.1.1",
        "LAYERS": "od_gis:Cykelparkering_Punkt"
      },
      // zoom ut: yttersta nivån lagret ska visas på
      minZoom: 4,
      // zoom in: lägsta nivån lagret ska visas på
      maxZoom: 9,
      // servertype: vilken typ av server det är.
      servertype: 'geoserver',
      // legend: lager teckenförklaring
      popup: {
        nameProperty: 'Id',
        template:
          '<span class="title">{{FEATURE_TYPE_NAME}}</span>'
      },
    }, {
      // Layer name
      name: 'Hundrastgårdar - POLYGON',
      // Layer URL
      url: 'https://openstreetgs.stockholm.se/geoservice/api/1e8d9bf1-79e5-4f60-94b3-1ddd776f66c3/wms?layers=od_gis:Hundrastgard_Yta',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 1,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "VERSION": "1.1.1",
        "LAYERS": "od_gis:Hundrastgard_Yta"
      },
      // zoom ut: yttersta nivån lagret ska visas på
      minZoom: 4,
      // zoom in: lägsta nivån lagret ska visas på
      maxZoom: 9,
      // servertype: vilken typ av server det är.
      servertype: 'geoserver',
      // legend: lager teckenförklaring
      popup: {
        nameProperty: 'Id',
        template:
          '<span class="title">{{OBJECT_ID}}</span>\
          <dl>\
            {{#Huvudman}}<dt>Huvudman</dt><dd>{{Huvudman}}</dd>{{/Huvudman}}\
          </dl>'
      },
    }, {
      // Layer name
      name: 'Servicedagar - LINESTRING',
      // Layer URL
      url: 'https://openstreetgs.stockholm.se/geoservice/api/1e8d9bf1-79e5-4f60-94b3-1ddd776f66c3/wms?layers=ltfr:LTFR_SERVICE_GROUP',
      // Visible from start
      showhide: false,
      // Layer type
      type: 'tileWMS',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 1,
      },
      // parameters: parametrar för kartserver
      parameters: {
        "FORMAT": "image/png",
        "VERSION": "1.1.1",
        "LAYERS": "ltfr:LTFR_SERVICE_GROUP"
      },
      // zoom ut: yttersta nivån lagret ska visas på
      minZoom: 4,
      // zoom in: lägsta nivån lagret ska visas på
      maxZoom: 9,
      // servertype: vilken typ av server det är.
      servertype: 'geoserver',
      // legend: lager teckenförklaring
      popup: {
        nameProperty: 'Id',
        template:
          '<span class="title">{{STREET_NAME}}</span>\
          <dl>\
              {{#ADDRESS}}<dt>Adress</dt><dd>{{ADDRESS}}</dd>{{/ADDRESS}}\
              {{#CITY_DISTRICT}}<dt>Stadsdel</dt><dd>{{CITY_DISTRICT}}</dd>{{/CITY_DISTRICT}}\
              {{#VF_PLATS_TYP}}<dt>Parkeringstyp</dt><dd>{{VF_PLATS_TYP}}</dd>{{/VF_PLATS_TYP}}\
              {{#START_WEEKDAY}}<dt>Start veckodag</dt><dd>{{START_WEEKDAY}}</dd>{{/START_WEEKDAY}}\
              {{#SERVICETID}}<dt>Servicetid</dt><dd>{{SERVICETID}}</dd>{{/SERVICETID}}\
          </dl>'
      },
    }, {
      // Layer name
      name: 'Cykelpumpar - WFS',
      // Layer URL
      url: 'https://openstreetgs.stockholm.se/geoservice/api/717ec6af-49f9-4774-84da-35b8cb713dc5/wfs?SERVICE=WFS&REQUEST=GetFeature&typename=od_gis:Cykelpump_Punkt&outputFormat=application/json&srsname=EPSG:3011',
      // Visible from start
      showhide: true,
      // Layer type
      type: 'WFS-geoJSON',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 2,
      },
      servertype: 'geoserver',
      poiType: '4',
      // legend: lager teckenförklaring
      legend: {
        // icon: Ikon till teckenförklaring
        icon: '4'
      },
      popup: {
        nameProperty: 'Adress',
        template:
          '<span class="title">{{Adress}}</span>\
          <dl>\
              {{#Modell}}<dt>Info</dt><dd>{{Modell}}</dd>{{/Modell}}\
              {{#Cykelventil}}<dt>Cykelventil</dt><dd>Ja</dd>{{/Cykelventil}}\
              {{#Racer_ventil}}<dt>Racerventil</dt><dd>Ja</dd>{{/Racer_ventil}}\
              {{#Bilventil}}<dt>Bilventil</dt><dd>Ja</dd>{{/Bilventil}}\
          </dl>'
      },
    }, {
      // name: lagernamn för lagret
      name: 'Intressepunkt',
      // Visible from start
      showhide: true,
      // clusterLayer: ifall man vill att lagret skall finnas i ett cluster lager
      clusterlayer: true,
      // Layer type
      type: 'geoJSON',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 3,
      },
      legend: {
        // icon: Ikon till teckenförklaring
        icon: "1",
      },
      // geojson: lagringsnamn för features i kartan
      geojson: {
        // features: feature i kartan är en punkt där man kan he en symbol i detta fallet Poi:ar
        "features": [{
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [154031, 6578889]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // name: namn på Poi
            "name": "Intressepunkt med länk",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk, placerad på Stortorget i Gamla stan. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [153710, 6579720]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med bild",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [154471, 6578079]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt med info lista",
            // name: namn på Poi
            "name": "Katarina kyrkobacke 24",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "<dl><dt>Info</dt><dd>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet.</dd><dt>Info lista</dt><dd>Lorem ipsum.</dd><dt>Rubrik</dt><dd>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</dd></dl>",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [154831, 6588829]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med länk",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [153785, 6578889]
          },
          //properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med bild",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [154600, 6578300]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med länk",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [153785, 6548145]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med bild",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [154875, 6578145]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med länk",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [153582, 6579458]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt exempel",
            // name: namn på Poi
            "name": "Intressepunkt med bild",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          // geometry: geometrin för Poi:en
          "geometry": {
            // point: typ av geometri
            "type": "Point",
            // coordinates: koordinaterna för punkten
            "coordinates": [155097, 6578685]
          },
          // properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Intressepunkt med lista",
            // name: namn på Poi
            "name": "Kastellholmen",
            // poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "1",
            // url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "",
            // content: informations text för Poi:en
            "content": "<ul><li>Lorem ipsum dolor</li><li>Dolore magna aliqua</li></ul>",
            // image: ifall man vill att poi:en skall innehålla en bild
            "image": ""
          }
        }]
      }
    }, {
      // name: lagernamn för lagret
      name: 'Intressepunkt blå',
      //showhide: synlighet av lager vid start
      showhide: true,
      // clusterLayer: ifall man vill att lagret skall finnas i ett cluster lager
      clusterlayer: true,
      //type: typ av lager
      type: 'geoJSON',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: false,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: '',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 4,
      },
      legend: {
        // icon: Ikon till teckenförklaring
        icon: "5",
      },
      //geojson: lagringsnamn för features i kartan
      geojson: {
        //features: feature i kartan är en punkt där man kan he en symbol i detta fallet Poi:ar
        "features": [{
          //geometry: geometrin för Poi:en
          "geometry": {
            //point: typ av geometri
            "type": "Point",
            //coordinates: koordinaterna för punkten
            "coordinates": [154131, 6578889]
          },
          //properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            // rubrik för Poi
            "header": "Egen rubrik blå",
            //name: namn på Poi
            "name": "Intressepunkt Köpmangatan",
            //poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "5",
            //url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            //content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk, placerad på Köpmangatan. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            //image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }, {
          //geometry: geometrin för Poi:en
          "geometry": {
            //point: typ av geometri
            "type": "Point",
            //coordinates: koordinaterna för punkten
            "coordinates": [154181, 6578889]
          },
          //properties: all data för innehållet i en Poi
          "properties": {
            "type": "Feature",
            //name: namn på Poi
            "name": "Intressepunkt Köpmantorget",
            //poiType: vilken typ av symbol som man vill ha i kartan för denna Poi
            "poiType": "5",
            //url: ifall man vill att Poi:en skall innehålla en url länk till en annan sida
            "url": "https://etjanstpp.stockholm.se/styleguide/karta/styleguide.html",
            //content: informations text för Poi:en
            "content": "Ingress text till intressepunkt popup med bild och länk, placerad på Köpmantorget. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            //image: ifall man vill att poi:en skall innehålla en bild
            "image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARIAAACdCAAAAABdzahGAAAC7klEQVR42u3b23GrMBCA4fTkUwANUIAKMAWEAkIBdgEqIH6PKSAUAAW4AChAFKDjXEcCjMRMTs5Y+++jzTDDN6vbsjzsiEk8QAAJJJBAAgkkkEACCSSQQAIJJJAQkEACCSSQQAIJJJBAAgkkkEACCQEJJJBAAgkkkEACCSSBqG04TCaJJLcxcZJEUkeR2FwOSVySWPsqhyQySawtpJDEJom1Fykk0UlibSWDJD5JrO0zESSvG0h+dSH+byRnuynK5Emy1m6MQ9Ik+f5s7Obon/b3TmL/cUACCSSQQAIJJD9GMnQn/RanbhRCMtZaX24+YVO5xTN1vAggad5Ps9ViAox6ftTN6zFxkq8yUBUH8n4QqtMm+T7KzkZEd7vcXAwpk3z/rid/HFdPzI08kjFUQ6zTJcmXnzFcfK+TJdFfQ8FsrTM3yS7CaqGcpqMqcEOyWzV9HTuP3nrTzettT/pxVjwrBG3olZ8Nh08vcy4ippMkSWrv+rJ3/nrxNm+5FJLR26JNXmIYFUqTFEnqFZGJSS6ExJ0wjgvdR24SXUSQjKHJonUu0CJI6uAOtVxdhxMkcY57WbitRASJM5WU4Sa1QQJJvjpTTBOpk0CyW3ve2REIktkZ6ATJRwV7rUKQNknDwJkeg5leZ4uwCi9KIvYln6Piz/KuY7JVy0WQOHPn0vsuf0NfyTgJuxcP60vw0iEoRRInCXZqXK0wZUYGSeOVGacmowoMrCRrr16hcZInF6/Q2MssR2d6vNVLUEl9abHLquZtmh2aym+uyHo5JG3cnbSkXrWoF6ClrPa9iK/2lJFFYlToNrmR1uQZMlG9vL5XU67dpDAiW4Gft641Arqj+xuTbNELbhhvF1CKVngPfa+9eVY993xWcJ1oW33YX0PrNuZrSAkkfHwCCSSQQAIJJJBA8lskdxuQQAIJJJBAAgkkkEACCSSQQAIJJAQkkEACCSSQQAIJJJBAAgkkkEBCQAIJJJBAAgkkkEACyV3GX0eztuDw36V2AAAAAElFTkSuQmCC"
          }
        }]
      }
    }, {
      // Layer name
      name: 'Stockholm - WMTS',
      // Layer URL
      url: 'http://kartor.stockholm.se/bios/wmts/app/baggis/web/WMTS_ALL/1.0.0/WMTSCapabilities.xml',
      capabilitiesXml: "<Capabilities xmlns='http://www.opengis.net/wmts/1.0' xmlns:ows='http://www.opengis.net/ows/1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:ns4='http://www.opengis.net/gml' xmlns:ns5='http://www.w3.org/2001/SMIL20/' xmlns:ns6='http://www.w3.org/2001/SMIL20/Language' version='1.0.0'><ows:ServiceIdentification><ows:Title>Digpro WMTS</ows:Title><ows:ServiceType>OGC WMTS</ows:ServiceType><ows:ServiceTypeVersion>1.0.0</ows:ServiceTypeVersion></ows:ServiceIdentification><ows:ServiceProvider><ows:ProviderName>Digpro AB</ows:ProviderName></ows:ServiceProvider><ows:OperationsMetadata><ows:Operation name='GetCapabilities'><ows:DCP><ows:HTTP><ows:Get xlink:href='http://kartor.stockholm.se:80/bios/wmts/app/baggis/web/WMTS_ALL/1.0.0/WMTSCapabilities.xml'><ows:Constraint name='GetEncoding'><ows:AllowedValues><ows:Value>RESTful</ows:Value></ows:AllowedValues></ows:Constraint></ows:Get></ows:HTTP></ows:DCP></ows:Operation><ows:Operation name='GetTile'><ows:DCP><ows:HTTP><ows:Get xlink:href='http://kartor.stockholm.se:80/bios/wmts/app/baggis/web/WMTS_ALL/1.0.0'><ows:Constraint name='GetEncoding'><ows:AllowedValues><ows:Value>RESTful</ows:Value></ows:AllowedValues></ows:Constraint></ows:Get></ows:HTTP></ows:DCP></ows:Operation></ows:OperationsMetadata><Contents><Layer><ows:Title>Stockholmskarta gra_gron Stockholms stad</ows:Title><ows:WGS84BoundingBox><ows:LowerCorner>17.73540698970735 59.20019773730185</ows:LowerCorner><ows:UpperCorner>18.26459301029265 59.46949251212496</ows:UpperCorner></ows:WGS84BoundingBox><ows:Identifier>1002120_3011</ows:Identifier><ows:BoundingBox crs='EPSG:3011'><ows:LowerCorner>135000.0 6565000.0</ows:LowerCorner><ows:UpperCorner>165000.0 6595000.0</ows:UpperCorner></ows:BoundingBox><Style isDefault='true'><ows:Identifier>default</ows:Identifier></Style><Format>image/png</Format><TileMatrixSetLink><TileMatrixSet>1002120_3011</TileMatrixSet></TileMatrixSetLink><ResourceURL format='image/png' resourceType='tile' template='http://kartor.stockholm.se:80/bios/wmts/app/baggis/web/WMTS_ALL/1.0.0/1002120/default/1002120_5850/{TileMatrix}/{TileRow}/{TileCol}.png'/></Layer><Layer><ows:Title>Stadens manér Stockholms stad</ows:Title><ows:WGS84BoundingBox><ows:LowerCorner>16.392112626454928 58.27664312985253</ows:LowerCorner><ows:UpperCorner>20.751260799157887 60.44739362118056</ows:UpperCorner></ows:WGS84BoundingBox><ows:Identifier>1005020_3011</ows:Identifier><ows:BoundingBox crs='EPSG:3011'><ows:LowerCorner>61500.0 6465000.0</ows:LowerCorner><ows:UpperCorner>301500.0 6705000.0</ows:UpperCorner></ows:BoundingBox><Style isDefault='true'><ows:Identifier>default</ows:Identifier></Style><Format>image/png</Format><TileMatrixSetLink><TileMatrixSet>1005020_3011</TileMatrixSet></TileMatrixSetLink><ResourceURL format='image/png' resourceType='tile' template='http://kartor.stockholm.se:80/bios/wmts/app/baggis/web/WMTS_ALL/1.0.0/1005020/default/1005020_5850/{TileMatrix}/{TileRow}/{TileCol}.png'/></Layer><TileMatrixSet><ows:Identifier>1002120_3011</ows:Identifier><ows:SupportedCRS>EPSG:3011</ows:SupportedCRS><TileMatrix><ows:Identifier>0</ows:Identifier><ScaleDenominator>418526.78571428574</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>1</MatrixWidth><MatrixHeight>1</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>1</ows:Identifier><ScaleDenominator>209263.39285714287</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>2</MatrixWidth><MatrixHeight>2</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>2</ows:Identifier><ScaleDenominator>104631.69642857143</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>4</MatrixWidth><MatrixHeight>4</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>3</ows:Identifier><ScaleDenominator>52315.84821428572</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>8</MatrixWidth><MatrixHeight>8</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>4</ows:Identifier><ScaleDenominator>26157.92410714286</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>16</MatrixWidth><MatrixHeight>16</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>5</ows:Identifier><ScaleDenominator>13078.96205357143</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>32</MatrixWidth><MatrixHeight>32</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>6</ows:Identifier><ScaleDenominator>6539.481026785715</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>64</MatrixWidth><MatrixHeight>64</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>7</ows:Identifier><ScaleDenominator>3269.7405133928573</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>128</MatrixWidth><MatrixHeight>128</MatrixHeight></TileMatrix></TileMatrixSet><TileMatrixSet><ows:Identifier>1002090_3011</ows:Identifier><ows:SupportedCRS>EPSG:3011</ows:SupportedCRS><TileMatrix><ows:Identifier>0</ows:Identifier><ScaleDenominator>418526.78571428574</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>1</MatrixWidth><MatrixHeight>1</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>1</ows:Identifier><ScaleDenominator>209263.39285714287</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>2</MatrixWidth><MatrixHeight>2</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>2</ows:Identifier><ScaleDenominator>104631.69642857143</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>4</MatrixWidth><MatrixHeight>4</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>3</ows:Identifier><ScaleDenominator>52315.84821428572</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>8</MatrixWidth><MatrixHeight>8</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>4</ows:Identifier><ScaleDenominator>26157.92410714286</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>16</MatrixWidth><MatrixHeight>16</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>5</ows:Identifier><ScaleDenominator>13078.96205357143</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>32</MatrixWidth><MatrixHeight>32</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>6</ows:Identifier><ScaleDenominator>6539.481026785715</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>64</MatrixWidth><MatrixHeight>64</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>7</ows:Identifier><ScaleDenominator>3269.7405133928573</ScaleDenominator><TopLeftCorner>135000.0 6595000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>128</MatrixWidth><MatrixHeight>128</MatrixHeight></TileMatrix></TileMatrixSet><ows:Identifier>1005020_3011</ows:Identifier><ows:SupportedCRS>EPSG:3011</ows:SupportedCRS><TileMatrix><ows:Identifier>0</ows:Identifier><ScaleDenominator>3348214.285714286</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>1</MatrixWidth><MatrixHeight>1</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>1</ows:Identifier><ScaleDenominator>1674107.142857143</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>2</MatrixWidth><MatrixHeight>2</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>2</ows:Identifier><ScaleDenominator>837053.5714285715</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>4</MatrixWidth><MatrixHeight>4</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>3</ows:Identifier><ScaleDenominator>418526.78571428574</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>8</MatrixWidth><MatrixHeight>8</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>4</ows:Identifier><ScaleDenominator>209263.39285714287</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>16</MatrixWidth><MatrixHeight>16</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>5</ows:Identifier><ScaleDenominator>104631.69642857143</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>32</MatrixWidth><MatrixHeight>32</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>6</ows:Identifier><ScaleDenominator>52315.84821428572</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>64</MatrixWidth><MatrixHeight>64</MatrixHeight></TileMatrix><TileMatrix><ows:Identifier>7</ows:Identifier><ScaleDenominator>26157.92410714286</ScaleDenominator><TopLeftCorner>61500.0 6705000.0</TopLeftCorner><TileWidth>256</TileWidth><TileHeight>256</TileHeight><MatrixWidth>128</MatrixWidth><MatrixHeight>128</MatrixHeight></TileMatrix></TileMatrixSet></Contents></Capabilities>",
      layer: '1002120_3011',
      // Sthlm manér layer: '1005020_3011',
      // Visible from start
      showhide: false,
      // zoomnivåer
      zoom: 7,
      maxZoom: 16,
      minZoom: 5,
      singelPopupZoomLevel: 14,
      geolocationZoomLevel: 12,
      // Layer type
      type: 'wmts',
      placement: {
        // backgroundlayer: ifall detta lagret skall vara ett bakgrundslager eller ej
        backgroundlayer: true,
        //backgroundlayername: namnet på grupperingen som ni vill att detta lagret skall ingå i. (ej nödvändigt ifall lagret ej är ett bakgrundslager)
        backgroundlayername: 'Bakgrundskarta',
        // order: ju högre värde numret har ju högre i position hamnar lagret, i respektive bakgrundslager eller kartlager.
        order: 6,
      },
      servertype: 'geoserver',
      legend: {
        // header: huvudrubrik för teckenförklaring
        "header": "Rubrik",
        // subheader: rubrik för ingress i tekenförklaring
        "subheader": "Ingress (kort beskrivning av kartlager)",
        // content: brödtext för teckenförklaring
        "content": [{
          //header: huvudrubrik för objekt
          "header": "Teckenrubrik",
          // text: text för objekt
          "text": "Teckenförklaring (kort beskrivning)",
          // image: bild för objekt
          "image": ""
        }, {
          //header: huvudrubrik för objekt
          "header": "",
          // text: text för objekt
          "text": "Teckenförklaring (kort beskrivning)",
          // image: bild för objekt
          "image": ""
        }]
      }
    }
  ]
}
/* END: DATA FOR MAP */

/* START: ACTIVATE MAP */
setTimeout(function () {
  var l = smap.init(data, '#s-map', '.s-map-container');
  console.log(l);
}, 500);
/* END: ACTIVATE MAP */
